import axios from 'axios';
import initRequestInterceptor from './apiInterceptorRequest';
import initResponseInterceptor from './apiInterceptorResponse';
import { getApiUrl } from "../component/helpers/helperAccount";

const API_URL = getApiUrl(); // process.env.REACT_APP_API_URL
const api = axios.create({
    baseURL: API_URL,
    withCredentials: true,
});

// Attach interceptors immediately
initRequestInterceptor(api);
initResponseInterceptor(api);

export { api };
